/**
 * ThemePreview — мини-макет кабинета в цветах темы.
 *
 * Приём взят из магазина тем школы: человек должен видеть, ЧТО покупает.
 * Раньше в Рублоксе тема показывалась цветным квадратиком-градиентом —
 * по нему невозможно понять, как будет выглядеть интерфейс.
 *
 * Рисуем схематичный кабинет: сайдбар, шапку, пару карточек. Цвета берём
 * из палитры самой темы (theme/cabThemes), поэтому превью автоматически
 * совпадает с тем, что человек увидит после применения.
 */
import React from "react";
import { CAB_THEMES } from "../../theme/cabThemes";

/** Значение переменной темы с откатом на дефолт светлой палитры. */
function v(theme, name, fallback) {
  return theme?.vars?.[name] || fallback;
}

export default function ThemePreview({ themeKey }) {
  const t = CAB_THEMES[themeKey] || CAB_THEMES.classic;

  // Дефолты — палитра «Классики»: у неё vars пустой, потому что она
  // и есть базовая тема кабинета.
  const bg = v(t, "--cab-bg", "#f5f7fb");
  const card = v(t, "--cab-card", "#ffffff");
  const border = v(t, "--cab-border", "#e2e8f0");
  const accent = v(t, "--cab-blue", "#3357ff");
  const text = v(t, "--cab-text", "#0a0e1a");
  const muted = v(t, "--cab-text-muted", "#6b7280");

  return (
    <div className="rb-thpv" style={{ background: bg }} aria-hidden="true">
      {/* сайдбар */}
      <div className="rb-thpv__side" style={{ background: card, borderColor: border }}>
        <div className="rb-thpv__logo" style={{ background: accent }} />
        <div className="rb-thpv__nav" style={{ background: accent, opacity: 0.9 }} />
        <div className="rb-thpv__nav" style={{ background: muted, opacity: 0.35 }} />
        <div className="rb-thpv__nav" style={{ background: muted, opacity: 0.35 }} />
      </div>

      {/* контент */}
      <div className="rb-thpv__main">
        <div className="rb-thpv__topbar">
          <div className="rb-thpv__title" style={{ background: text, opacity: 0.75 }} />
          <div className="rb-thpv__pill" style={{ background: accent }} />
        </div>
        <div className="rb-thpv__cards">
          <div className="rb-thpv__card" style={{ background: card, borderColor: border }}>
            <div className="rb-thpv__line" style={{ background: text, opacity: 0.5 }} />
            <div className="rb-thpv__line rb-thpv__line--short" style={{ background: muted, opacity: 0.4 }} />
          </div>
          <div className="rb-thpv__card" style={{ background: card, borderColor: border }}>
            <div className="rb-thpv__line" style={{ background: text, opacity: 0.5 }} />
            <div className="rb-thpv__line rb-thpv__line--short" style={{ background: muted, opacity: 0.4 }} />
          </div>
        </div>
      </div>
    </div>
  );
}
